import {ErrorMessage} from "@hookform/error-message"
import { Controller, useForm } from "react-hook-form"
import {
  AllDefaultValues,
  AllStepFormType,
  CLIENT_ADD_STEPS,
} from "@/types/StepForm"
import {
  EnterpriseFormFieldNameEnum,
  EnterpriseFormType,
} from "@/types/EnterpriseForm"
import PhoneInput, {handleValidate} from "components/common/phoneInput/PhoneInput"
import React, { SetStateAction, useContext, useEffect, useMemo, useState } from "react"
import {COMPANY_LEGAL_FORM_CHOICES} from "@/constants/CompaniesConstants"
import { Input } from "components/ui/input"
import CustomSelectGroup from "components/common/selectGroup/CustomSelectGroup"
import FileUploadInput from "components/common/fileUploadInput/FileUploadInput"
import IfuInput from "components/common/ifuInput/IfuInput"
import CustomDatePicker from "components/common/datepicker/CustomDatePicker"
import CustomRadioButton from "components/common/radio-blocks-group/CustomRadioButton"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "@/hooks/reduxToolkitHook"
import { CompanyFormType, CompanyType1 } from "@/types/CompaniesType"
import { StepperNavigationButtons } from "components/common/stepper/StepperNavigationButtons"
import {
  createAsyncCompany,
  updateAsyncCompany,
} from "@/redux/features/companiesSlice"
import {
  ActionNotificationContext,
  ActionNotificationContextValeurType,
} from "@/context/ActionNotificationContext"
import { useStepperNavigation } from "components/common/stepper/CustomStepper"
import { transformDataBasedOnActiveStep } from "@/helpers/stepForm"
import { replaceIdInLink } from "@/utils/utils"
import { CLIENT_INFOS_OVERVIEW_ROUTE } from "@/constants/mainRoutes"

export type StepEnterpriseProps = {}
// Omit<UseFormReturn<AllStepFormType>, "handleSubmit">

const StepEnterprise2 = (props: StepEnterpriseProps) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { displayAlert } = useContext(
    ActionNotificationContext,
  ) as ActionNotificationContextValeurType
  const { companies } = useAppSelector(state => state.companies)
  // const global = useAppSelector(state => state.global)
  const [updatingCompany, setUpdatingCompany] = useState<CompanyType1>();

  const [countryCode, setCountryCode] = useState("bj")
  const REGIME_OPTIONS = [
    { value: "TPS", label: "TPS" },
    {
      value: "REAL",
      label: "Régime réel (CA supérieur à 50  millions )",
    },
  ]
  // const [juridicFormRecord, setJuridicFormRecord] = useState("NO_JURIDIC_FORM")

  const methods = useForm<EnterpriseFormType>({
    defaultValues: AllDefaultValues[0],
    mode: "all",
  })
  const {
    control,
    setValue,
    watch,
    handleSubmit,
    formState: {errors},
  } = methods

  const vpsWatcher = watch("is_vps")

  const {
    goToNext,
  } = useStepperNavigation();

  const submit = (data : EnterpriseFormType) =>{
    // console.log(formData)
    // const formData = transformDataBasedOnActiveStep(1, formData as AllStepFormType, ) as FormData
    if(id) {
      delete data[EnterpriseFormFieldNameEnum.LOGO]
      try{
        dispatch(updateAsyncCompany({ id:id, data: data }))
          .then((result) => {
          if (updateAsyncCompany.fulfilled.match(result)) {
            displayAlert("Operation effectuée avec succès", "success")
            // console.log(replaceIdInLink(id, CLIENT_ADD_STEPS[1].pathName))
            goToNext(`${id}/${CLIENT_ADD_STEPS[1].pathName}`)
            // navigate(replaceIdInLink(id as string, CLIENT_INFOS_OVERVIEW_ROUTE))
            // dispatch(fetchOptions()).unwrap()
          } else if (updateAsyncCompany.rejected.match(result)) {
            displayAlert(
              "Une erreur est survenue lors de la modification du client",
              "error"
            )
          }
        })
      }catch(error) {
        displayAlert("Une erreur est survenue lors de la creation du client","error")
      }
    } else {

      try{
        const formaData = transformDataBasedOnActiveStep(1, data as AllStepFormType, ) as FormData
        dispatch(createAsyncCompany(formaData)).then((result) => {
          if (createAsyncCompany.fulfilled.match(result)) {
            // const url = replaceIdInLink( result.payload.id, CLIENT_ADD_STEPS[1].pathName)
            displayAlert("Operation effectuée avec succès", "success")
            goToNext(`${result.payload.id}/${CLIENT_ADD_STEPS[1].pathName}`)
          } else if (createAsyncCompany.rejected.match(result)) {
            displayAlert("Une erreur est survenue lors de la creation du client","error")
          }
        })
      }catch(error) {
        displayAlert("Une erreur est survenue lors de la creation du client","error")
        console.log(error.message)
      }
    }
  }

    useEffect(() => {
      if (vpsWatcher == "NO_VPS") {
        setValue(EnterpriseFormFieldNameEnum.VPS_RATE, "")
        setValue(EnterpriseFormFieldNameEnum.VPS_END_DATE, "")
      }
    }, [vpsWatcher])

    useEffect(() =>{
      if(updatingCompany){
        setValue(EnterpriseFormFieldNameEnum.COMPANY_NAME, updatingCompany?.name)
        setValue(EnterpriseFormFieldNameEnum.IFU, updatingCompany?.ifu)
        setValue(EnterpriseFormFieldNameEnum.CNSS, updatingCompany?.cnss)
        setValue(EnterpriseFormFieldNameEnum.LEGAL_FORM, updatingCompany?.legal_form )
        setValue(EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK, updatingCompany?.professional_risk.toString() )
        setValue("is_vps", (updatingCompany?.vps_rate || updatingCompany?.vps_end_date ) ? "VPS" : "NO_VPS" )
        setValue(EnterpriseFormFieldNameEnum.VPS_END_DATE, updatingCompany?.vps_end_date)
        setValue(EnterpriseFormFieldNameEnum.VPS_RATE, updatingCompany?.vps_rate?.toString())
        // setValue(EnterpriseFormFieldNameEnum.TAXE_REGIME, updatingCompany?.tax_system )
        setValue(EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT, updatingCompany?.collective_agreement )
        setValue(EnterpriseFormFieldNameEnum.ADDRESS, updatingCompany?.address )
        setValue(EnterpriseFormFieldNameEnum.CONTACT, updatingCompany?.contact )
        setValue(EnterpriseFormFieldNameEnum.EMAIL, updatingCompany?.email )
        setValue(EnterpriseFormFieldNameEnum.ADMIN_EMAIL, updatingCompany?.admin_email)
      } else{
        setValue(EnterpriseFormFieldNameEnum.COMPANY_NAME, "")
        setValue(EnterpriseFormFieldNameEnum.IFU, "")
        setValue(EnterpriseFormFieldNameEnum.CNSS, "")
        setValue(EnterpriseFormFieldNameEnum.LEGAL_FORM, "")
        setValue(EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK, "")
        setValue("is_vps", "NO_VPS")
        setValue(EnterpriseFormFieldNameEnum.VPS_END_DATE, "")
        setValue(EnterpriseFormFieldNameEnum.VPS_RATE, "")
        // setValue(EnterpriseFormFieldNameEnum.TAXE_REGIME, "")
        setValue(EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT, "")
        setValue(EnterpriseFormFieldNameEnum.ADDRESS, "")
      }
    }, [updatingCompany])

  useEffect(() => {
    setUpdatingCompany(companies.find(company => company.id === id))
  }, [companies])

  return (
    <>
      <form className="w-full">
        <div className="bg-white flex w-full justify-center py-3 px-8 pb-6 rounded-lg">
          <div className="w-full px-5 space-y-2">
            {
              !updatingCompany ?
                (<div className="pt-2">
                  <Controller
                    name={EnterpriseFormFieldNameEnum.LOGO}
                    control={control}
                    // rules={{
                    //   required: {
                    //     value: true,
                    //     message: "Vous devez choisir un fichier.",
                    //   },
                    // }}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <FileUploadInput
                        className="mt-5"
                        title=""
                        name={EnterpriseFormFieldNameEnum.LOGO}
                        showModelDoc={false}
                        onBlur={onBlur}
                        onChange={onChange}
                        value={value}
                        mimes="image/*"
                      />
                    )}
                  />
                  <ErrorMessage
                    className="text--error my-auto !mt-auto"
                    errors={errors}
                    name={EnterpriseFormFieldNameEnum.LOGO}
                    as="p"
                  />
                </div>) : null}

            <div className="pt-6">
              <label>Nom de votre entreprise (raison sociale)</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.COMPANY_NAME}
                control={control}
                rules={{
                  required: "Le nom de l'entreprise est requise.",
                }}
                render={({ field }) => (
                  <Input
                    placeholder="ERUGIS CONSULTING"
                    type="text"
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.COMPANY_NAME}
                as="p"
                className="text--error"
              />
            </div>

            <div className="pt-4">
              <label>Identifiant Fiscal Unique (IFU)</label>
              <IfuInput name={EnterpriseFormFieldNameEnum.IFU} control={control} />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.IFU}
                as="p"
                className="text--error"
              />
            </div>

            <div className="pt-2">
              <label>Numéro CNSS employeur</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.CNSS}
                control={control}
                rules={{
                  required: "Le numero CNSS est requise.",
                  validate: (value: string) =>
                    (/(^\d{5}$)|(^\d{14}$)/.test(value)) ||// value.replaceAll(/[_*\s]/g, "").trim().length == 14 ||
                    "Veuillez renseigner un numéro CNSS valide",
                }}
                render={({ field }) => (
                  <Input
                    placeholder="XXXXX ou XX XX XX XX XX XX XX"
                    type="text"
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                  // <InputMask
                  //   {...field}
                  //   mask="99 99 99 99 99 99 99"
                  //   placeholder="XX XX XX XX XX XX XX"
                  //   onBlur={field.onBlur}
                  //   onChange={(e) =>
                  //     field.onChange(e.target.value.replaceAll(" ", ""))
                  //   }>
                  //   {(inputProps) => (
                  //     <Input
                  //       {...inputProps}
                  //       className={cn("uppercase", "form--custom")}
                  //       type="text"
                  //     />
                  //   )}
                  // </InputMask>
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.CNSS}
                as="p"
                className="text--error"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label>Forme juridique</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.LEGAL_FORM}
                control={control}
                rules={{
                  required: "Choisissez une forme jurique",
                }}
                render={({ field }) => (
                  <div>
                    <CustomSelectGroup
                      name={EnterpriseFormFieldNameEnum.LEGAL_FORM}
                      id={EnterpriseFormFieldNameEnum.LEGAL_FORM}
                      value={field.value}
                      label="Forme juridique"
                      items={COMPANY_LEGAL_FORM_CHOICES}
                      placeholder="Choisir une option ..."
                      onChange={(e) => field.onChange(e)}
                    />
                  </div>
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.LEGAL_FORM}
                message="Valeur requise"
                as="p"
                className="text--error"
              />
            </div>

            {/*<div className="pt-2">*/}
            {/*  <Controller*/}
            {/*    name={EnterpriseFormFieldNameEnum.LEGAL_FORM}*/}
            {/*    control={control}*/}
            {/*    render={({field}) => (*/}
            {/*      <MuiSelect*/}
            {/*        selectProps={{...field, value: field.value ?? ""}}*/}
            {/*        label="Forme juridique"*/}
            {/*        options={COMPANY_LEGAL_FORM_CHOICES}*/}
            {/*      />*/}
            {/*    )}*/}
            {/*  />*/}
            {/*  <ErrorMessage*/}
            {/*    errors={errors}*/}
            {/*    name="juridic_form"*/}
            {/*    message="Valeur requise"*/}
            {/*    as="p"*/}
            {/*    className="text--error"*/}
            {/*  />*/}
            {/*</div>*/}

            <div className="flex flex-col gap-2 pt-4">
              <label> Risque Professionnel</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK}
                control={control}
                rules={{
                  required:
                    "Entrez une valeur numérique pour le risque professionel",
                  validate: (value: string) =>
                    (0 < Number(value) && Number(value) < 5) ||
                    "Veuillez renseigner une valeur comprise entre 1 et 4",
                }}
                render={({ field }) => (
                  <CustomSelectGroup
                    name={EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK}
                    id={EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK}
                    value={field.value}
                    label="Risque Professionnel"
                    items={[...Array(4).keys()].map((x) => ({
                      label: String(x + 1),
                      value: x + 1,
                    }))}
                    placeholder="Choisir une option ..."
                    onChange={(e: string) => field.onChange(e)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.PROFESSIONAL_RISK}
                message="Valeur requise"
                as="p"
                className="text--error"
              />
            </div>

            {/* VPS CONFIG */}
            <div className="pt-3">
              <label className=" mb-4">
                Bénéficie-t- il d'une exonération sur le VPS ?
              </label>
              <br />
              <div className="flex gap-4 mt-3">
                {[
                  { value: "VPS", label: "Oui" },
                  { value: "NO_VPS", label: "Non" },
                ].map((option, index) => (
                  <Controller
                    key={index}
                    name="is_vps"
                    control={control}
                    rules={{
                      required: "Cette valeur est requise",
                    }}
                    render={({ field }) => (
                      <CustomRadioButton
                        key={index}
                        value={option.value}
                        handleChange={(val) => {
                          field.onChange(val)
                        }}
                        labelTitle={option.label}
                        index={index}
                        recordState={field.value}
                        name="is_vps"
                      />
                    )}
                  />
                ))}
              </div>

              {/*<RadioBlocsGroup name="is_vps" options={[{ value: "VPS", label: "Oui" }, {value: "NO_VPS", label: "Non"}]}*/}
              {/*  className="flex items-center "*/}
              {/*  value={VPSExonerated}*/}
              {/*  onValueChange={(e) => setVPSExonerated(e)}*/}
              {/*/>*/}
              {/*<RadioGroup*/}
              {/*  aria-labelledby="regime-radio-buttons-group-label"*/}
              {/*  className="flex flex-row"*/}
              {/*  defaultValue="NO_VPS"*/}
              {/*  onChange={(e) => setVPSExonerated(e.target.value)}>*/}
              {/*  <FormControlLabel value={"VPS"} control={<Radio />} label="Oui" />*/}
              {/*  <FormControlLabel*/}
              {/*    value={"NO_VPS"}*/}
              {/*    control={<Radio />}*/}
              {/*    label="Non"*/}
              {/*  />*/}
              {/*</RadioGroup>*/}
            </div>

            {vpsWatcher == "VPS" && (
              <>
                <div className="pt-2">
                  <p>Versement patronal (VPS)</p>
                  <Controller
                    name={EnterpriseFormFieldNameEnum.VPS_RATE}
                    control={control}
                    rules={{
                      required: "Entrez une valeur numérique pour le vps",
                      validate: (value: string) =>
                        (0 <= Number(value) && Number(value) < 5) ||
                        "Veuillez renseigner une valeur comprise entre 0 et 4",
                    }}
                    render={({ field }) => (
                      <CustomSelectGroup
                        name={EnterpriseFormFieldNameEnum.VPS_RATE}
                        id={EnterpriseFormFieldNameEnum.VPS_RATE}
                        value={field.value}
                        defaultValue={"1"}
                        items={[...Array(4).keys()].map((x) => ({
                          label: String(x + 1),
                          value: x + 1,
                        }))}
                        placeholder="Choisir une option ..."
                        onChange={(e: string) => field.onChange(e)}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name={EnterpriseFormFieldNameEnum.VPS_RATE}
                    as="p"
                    className="text--error"
                  />
                </div>

                <div className="pt-1 pb-6">
                  {/*<label className="font-medium">*/}
                  {/*  */}
                  {/*</label>*/}
                  <Controller
                    name={EnterpriseFormFieldNameEnum.VPS_END_DATE}
                    control={control}
                    rules={{
                      // required: "Choisissez une date de debut",
                      // validate: (value: string) => value.length !== 10 ?
                      //   "Format de date invalide" : ""
                    }}
                    render={({ field }) => (
                      <CustomDatePicker
                        name={EnterpriseFormFieldNameEnum.VPS_END_DATE}
                        label="Date de fin de l'exonération du VPS (si c'est le cas)"
                        value={field.value}
                        placeholder="AAAA-MM-JJ"
                        onChange={(e: string) => field.onChange(e)}
                      />
                    )}
                  />
                  {/*<Controller*/}
                  {/*  name={EnterpriseFormFieldNameEnum.VPS_END_DATE}*/}
                  {/*  control={control}*/}
                  {/*  render={({ field }) => (*/}
                  {/*    <MuiDatePickerV2*/}
                  {/*      {...field}*/}
                  {/*      className="pt-2"*/}
                  {/*      minDate={new Date("01/01/2000")}*/}
                  {/*      selected={field.value}*/}
                  {/*      onChange={(date) => {*/}
                  {/*        field.onChange(date)*/}
                  {/*      }}*/}
                  {/*    />*/}
                  {/*  )}*/}
                  {/*/>*/}
                  <ErrorMessage
                    errors={errors}
                    name={EnterpriseFormFieldNameEnum.VPS_END_DATE}
                    as="p"
                    className="text--error"
                  />
                </div>
              </>
            )}

            {/* TPS CONFIG */}

            {/*<div className="pt-3">*/}
            {/*  <Controller*/}
            {/*    name={EnterpriseFormFieldNameEnum.TAXE_REGIME}*/}
            {/*    control={control}*/}
            {/*    rules={{*/}
            {/*      required: "Le régime d'impôt est requis",*/}
            {/*    }}*/}
            {/*    render={({ field }) => (*/}
            {/*      <>*/}
            {/*        <label className="font-medium mb-4">Régime d’impôt</label>*/}
            {/*        <br />*/}
            {/*        <div className="flex flex-col gap-4 mt-3">*/}
            {/*          {REGIME_OPTIONS.map((option, index) => (*/}
            {/*            <Controller*/}
            {/*              key={index}*/}
            {/*              name={EnterpriseFormFieldNameEnum.TAXE_REGIME}*/}
            {/*              control={control}*/}
            {/*              rules={{*/}
            {/*                required: "Cette valeur est requise",*/}
            {/*              }}*/}
            {/*              render={({ field }) => (*/}
            {/*                <CustomRadioButton*/}
            {/*                  key={index}*/}
            {/*                  value={option.value}*/}
            {/*                  handleChange={(val) => {*/}
            {/*                    field.onChange(val)*/}
            {/*                  }}*/}
            {/*                  labelTitle={option.label}*/}
            {/*                  index={index}*/}
            {/*                  recordState={field.value}*/}
            {/*                  name={EnterpriseFormFieldNameEnum.TAXE_REGIME}*/}
            {/*                />*/}
            {/*              )}*/}
            {/*            />*/}
            {/*          ))}*/}
            {/*        </div>*/}
            {/*      </>*/}
            {/*    )}*/}
            {/*  />*/}
            {/*  <ErrorMessage*/}
            {/*    errors={errors}*/}
            {/*    name={EnterpriseFormFieldNameEnum.TAXE_REGIME}*/}
            {/*    as="p"*/}
            {/*    className="text--error"*/}
            {/*  />*/}
            {/*</div>*/}

            <div className="pt-5">
              <label>Adresse</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.ADDRESS}
                control={control}
                rules={{
                  required: "L'adresse de l'entreprise est requise.",
                }}
                render={({ field }) => (
                  <Input
                    placeholder="Calavi ABOMEY-CALAVI, 7ième Rue à droite après carrefour IITA"
                    type="text"
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.ADDRESS}
                as="p"
                className="text--error"
              />
            </div>

            <div className="py-2 space-y-2">
              <p className="text-black3 text-sm">
                Conventions collectives
              </p>
              <Controller
                name={EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT}
                control={control}
                rules={{
                  required: "Choisissez une convention collective.",
                }}
                render={({ field }) => (
                  <CustomSelectGroup
                    name={EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT}
                    id={EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT}
                    value={field.value}
                    label="Convention collective"
                    // defaultValue="GENERAL"
                    items={[
                      {
                        label: "Convention Collective Générale du Bénin",
                        value: "GENERAL",
                      },
                      {
                        label: "Convention Collective des Assurances du Bénin",
                        value: "ASA",
                      },
                    ]}
                    placeholder="Type de convention"
                    onChange={(e: string) => field.onChange(e)}
                  />
                )}
              />
              {/*<Controller*/}
              {/*  name={EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT}*/}
              {/*  control={control}*/}
              {/*  rules={{*/}
              {/*    required: "Choisissez une convention collective.",*/}
              {/*  }}*/}
              {/*  render={({ field }) => (*/}
              {/*    <MuiSelect*/}
              {/*      selectProps={{ ...field, value: field.value ?? "" }}*/}
              {/*      label="Convention collective"*/}
              {/*      placeholder="Type de convention"*/}
              {/*      options={[*/}
              {/*        {*/}
              {/*          label: "Convention Collective Générale du Bénin",*/}
              {/*          value: "GENERAL",*/}
              {/*        },*/}
              {/*        {*/}
              {/*          label: "Convention Collective des Assurances du Bénin",*/}
              {/*          value: "ASA",*/}
              {/*        },*/}
              {/*      ]}*/}
              {/*    />*/}
              {/*  )}*/}
              {/*/>*/}
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.COLLECTIVE_AGREEMENT}
                as="p"
                className="text--error"
              />
            </div>

            <div className="pt-2">
              <label className="font-medium mb-4">Contact</label>
              <br />
              <Controller
                name={EnterpriseFormFieldNameEnum.CONTACT}
                control={control}
                rules={{
                  required: "Veuillez renseigner le numéro de téléphone",
                  validate: (value) =>
                    handleValidate(value, countryCode) ||
                    "Le numéro n'est pas valide pour le pays sélectionné",
                }}
                render={({ field }) => (
                  <>
                    <PhoneInput
                      defaultCountry={"bj"}
                      isCodeEditable={false}
                      onChange={(
                        value: any,
                        country: { countryCode: SetStateAction<string> }
                      ) => {
                        setCountryCode(country.countryCode)
                        field.onChange(value)
                      }}
                      value={field.value}
                    />
                  </>
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.CONTACT}
                as="p"
                className="text--error"
              />
            </div>

            <br />

            <div className="pt-2">
              <label>Email Entreprise</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.EMAIL}
                control={control}
                rules={{
                  required: "L'email est requis.",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Entrez un email valid",
                  },
                }}
                render={({ field }) => (
                  <Input
                    placeholder="adresse@mail.com"
                    type="email"
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.EMAIL}
                as="p"
                className="text--error"
              />
            </div>

            <div className="pt-2">
              <label>Email Connexion Entreprise</label>
              <Controller
                name={EnterpriseFormFieldNameEnum.ADMIN_EMAIL}
                control={control}
                rules={{
                  required: "L'email est requis.",
                  pattern: {
                    value: /\S+@\S+\.\S+/,
                    message: "Entrez un email valid",
                  },
                }}
                render={({ field }) => (
                  <Input
                    placeholder="adresse@mail.com"
                    type="email"
                    value={field.value}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={EnterpriseFormFieldNameEnum.ADMIN_EMAIL}
                as="p"
                className="text--error"
              />
            </div>
          </div>
        </div>
        <StepperNavigationButtons handleNext={handleSubmit(submit)} />
      </form>
    </>
  )
}

export default StepEnterprise2
